import React from 'react';

function Panel(props) {
  return (
    <div className={`panel panel-${props.theme ? props.theme : 'inverse'} ${props.className ? props.className : ''}`}>
      {props.children}
    </div>
  );
}

function PanelHeader(props) {
  return (
    <div className={`panel-heading ${props.className}`}>
      <h4 className="panel-title">{props.children}</h4>
    </div>
  );
}

function PanelBody(props) {
  return (
    <div className={`panel-body ${props.className}`}>
      {props.children}
    </div>
  );
}

function PanelFooter(props) {
  return <div className={`panel-footer ${props.className}`}>{props.children}</div>;
}

export { Panel, PanelHeader, PanelBody, PanelFooter };
